export const defineProperty = (eventProperties: any, keyV: any, valueV: any): void  => {
  Object.defineProperty(eventProperties, keyV, {value: valueV, writable: true, enumerable: true, configurable: true});
};
